<div class="title-large" style="display: flex;align-items: center; gap: 8px;margin-bottom: 24px">
  <span (click)="drawer.close()" class="material-symbols-rounded" style="cursor: pointer;padding: 6px">west</span>
  Previous messages
</div>

<mat-tab-group style="width: 600px;background: var(--background)">

  <mat-tab data-testid="expandFavoriteItems" label="Favorites">
    <div style="height: 24px"></div>


    @for (favMessage of favorites(); track favMessage.id) {

      <div class="title-small"
           style="margin-bottom: 8px;font-weight: 500">{{ favMessage.dateAdded.toDate()|date:"dd MMM yyy HH:mm" }}
      </div>

      <div class="message-container">
        <div data-testid="favoriteTitle" class="title-small"
             style="margin-bottom: 12px">{{ favMessage.englishTitle ?? favMessage.title }}
        </div>
        <div data-testid="favoriteMessage" class="body-large"
             style="margin-bottom: 12px">{{ favMessage.englishMessage ?? favMessage.message }}
        </div>

        <span data-testid="options" [matMenuTriggerFor]="menu" class="material-symbols-rounded"
              style="position:absolute;right:8px;top:8px;cursor: pointer">more_vert</span>
        <mat-menu #menu="matMenu" class="test-me">
          <button mat-menu-item (click)="delete(favMessage)">Delete</button>
          <button data-testid="copyMessageButton" mat-menu-item (click)="copyMessage.emit(favMessage)">Copy</button>
        </mat-menu>

      </div>
    }
  </mat-tab>
  <mat-tab data-testid="expandHistoryItems" label="History">

    <div style="height: 24px"></div>


    @for (historyMessage of history$ | async; track historyMessage) {

      <div class="title-small"
           style="margin-bottom: 8px;font-weight: 500">{{ historyMessage.dateAdded.toDate()|date:"dd MMM yyy HH:mm" }}
      </div>

      <div class="message-container">
        <div class="title-small" style="margin-bottom: 12px">{{ historyMessage.englishTitle ?? historyMessage.title }}
        </div>
        <div class="body-large"
             style="margin-bottom: 12px">{{ historyMessage.englishMessage ?? historyMessage.message }}
        </div>

        <span [matMenuTriggerFor]="menu" class="material-symbols-rounded"
              style="position:absolute;right:8px;top:8px;cursor: pointer">more_vert</span>
        <mat-menu #menu="matMenu" class="test-me">
          <button mat-menu-item (click)="addToFavorites(historyMessage)">Add to favorites</button>
        </mat-menu>

      </div>
    }


  </mat-tab>

</mat-tab-group>



